<template>
    <div class="x-select-item-search-content">
        <x-checkbox-icon v-model="searchByBarcode"
                         tooltip-content="Buscar por código de barras"
                         :border="true"
                         @input="$emit('change-barcode', searchByBarcode)"
                         v-if="showButtonBarcode"
                         icon="fa-light fa-barcode"></x-checkbox-icon>
        <el-select v-model="itemSelect"
                   ref="xSelectItemSearch"
                   :name="name"
                   :loading="loading"
                   filterable
                   remote
                   :remote-method="searchItem"
                   @change="selectItem"
                   :placeholder="`${searchByBarcode?'Buscar por código de barras':'Buscar por nombre, código interno del producto, escribir mínimo 2 caracteres'}`"
                   popper-class="x-select-item-search"
                   style="width: 100%">
            <el-option v-for="item in items"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
                <div class="x-item-search">
                    <div class="x-item-search_image"><img :src="item.image"/></div>
                    <div class="x-item-search_information">
                        <div class="x-item-search_information_name">{{ item.name }}</div>
                        <div class="x-item-search_information_description">
                            <span v-if="item.information">{{ item.information }}</span>
                        </div>
                    </div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
import XCheckboxIcon from "./XCheckboxIcon.vue";

export default {
    name: 'XSelectItemSearch',
    components: {XCheckboxIcon},
    props: {
        warehouseId: {
            default: 'all'
        },
        name: {
            type: String,
            default: 'x-select-item-search'
        },
        clearSearchItem: {
            type: Boolean,
            default: false,
        },
        showButtonBarcode: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            loading: false,
            items: [],
            itemSelect: '',
            searchByBarcode: false
        }
    },
    watch: {
        warehouseId(val) {
            this.items = [];
            this.itemSelect = '';
        },
        clearSearchItem(val) {
            if (val) {
                this.items = [];
                this.itemSelect = '';
                this.$emit('update:clear-search-item', false)
            }
        }
    },
    methods: {
        async searchItem(input) {
            this.items = [];
            if (!_.isUndefined(input) && !_.isNull(input) && input.length > 1) {
                let debounce_fun = _.debounce(async () => {
                    await this.$http.post(`/store/get_items`, {
                        'input': input,
                        'warehouse_id': this.warehouseId,
                        'search_by_barcode': this.searchByBarcode
                    })
                        .then(response => {
                            this.items = response.data;
                        });

                    if (this.searchByBarcode) {
                        if (this.items.length === 1) {
                            this.itemSelect = this.items[0].id
                            this.selectItem(this.itemSelect)
                            this.$refs.xSelectItemSearch.blur();
                        }
                    }

                }, 500);
                debounce_fun();
            }
        },
        selectItem(id) {
            let item = _.find(this.items, {'id': id});
            let it = {
                'id': item.id,
                'image': item.image,
                'name': item.name,
                'information': item.information,
                'stock_add': 0
            }
            this.$emit('select', it)
        }
    }
}
</script>
